document.addEventListener('DOMContentLoaded', () => {
  const searchElements = [...document.querySelectorAll('[data-md-predictive-search]')];
  if (!searchElements.length) return;

  const searches = [];

  const resetActiveOption = (state) => {
    state.activeIndex = -1;
    state.input.removeAttribute('aria-activedescendant');
    state.options.forEach((option) => {
      option.classList.remove('is-active');
      option.setAttribute('aria-selected', 'false');
    });
  };

  const closeSearch = (state, { abort = true, focus = false } = {}) => {
    window.clearTimeout(state.timeout);

    if (abort && state.controller) {
      state.controller.abort();
      state.controller = null;
    }

    resetActiveOption(state);
    state.options = [];
    state.results.innerHTML = '';
    state.results.hidden = true;
    state.input.setAttribute('aria-expanded', 'false');
    state.input.setAttribute('aria-controls', state.results.id);

    if (focus) state.input.focus();
  };

  const setActiveOption = (state, index) => {
    if (!state.options.length) return;

    const safeIndex = (index + state.options.length) % state.options.length;
    state.activeIndex = safeIndex;

    state.options.forEach((option, optionIndex) => {
      const active = optionIndex === safeIndex;
      option.classList.toggle('is-active', active);
      option.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    const activeOption = state.options[safeIndex];
    state.input.setAttribute('aria-activedescendant', activeOption.id);
    activeOption.scrollIntoView({ block: 'nearest' });
  };

  searchElements.forEach((search, searchIndex) => {
    const input = search.querySelector('input[type="search"]');
    const results = search.querySelector('[data-md-search-results]');

    if (!input || !results) return;

    if (!results.id) results.id = `MDSearchResults-${searchIndex + 1}`;
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', results.id);

    const state = {
      search,
      input,
      results,
      timeout: null,
      controller: null,
      options: [],
      activeIndex: -1,
    };

    searches.push(state);

    input.addEventListener('input', () => {
      window.clearTimeout(state.timeout);
      resetActiveOption(state);

      if (state.controller) {
        state.controller.abort();
        state.controller = null;
      }

      const term = input.value.trim();

      if (term.length < 2) {
        closeSearch(state, { abort: false });
        return;
      }

      state.timeout = window.setTimeout(async () => {
        const controller = new AbortController();
        state.controller = controller;

        const url =
          `${window.Shopify?.routes?.root || '/'}search/suggest` +
          `?q=${encodeURIComponent(term)}` +
          `&resources[type]=product,collection` +
          `&resources[limit]=6` +
          `&section_id=md-predictive-search`;

        try {
          const response = await fetch(url, { signal: controller.signal });

          if (!response.ok) throw new Error('Predictive search request failed');

          const html = await response.text();
          if (controller.signal.aborted || input.value.trim() !== term) return;

          const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
          const content = parsedHtml.querySelector('[data-md-predictive-search-results]');

          if (!content) {
            closeSearch(state, { abort: false });
            return;
          }

          results.innerHTML = content.outerHTML;
          results.hidden = false;

          const listbox = results.querySelector('[data-md-search-listbox]');
          if (listbox) {
            listbox.id = `${results.id}-listbox`;
            input.setAttribute('aria-controls', listbox.id);
          }

          state.options = [...results.querySelectorAll('[role="option"]')];
          state.options.forEach((option, optionIndex) => {
            option.id = `${results.id}-option-${optionIndex + 1}`;
            option.setAttribute('aria-selected', 'false');

            option.addEventListener('mouseenter', () => setActiveOption(state, optionIndex));
            option.addEventListener('focus', () => setActiveOption(state, optionIndex));
          });

          input.setAttribute('aria-expanded', 'true');
        } catch (error) {
          if (error.name === 'AbortError') return;
          closeSearch(state, { abort: false });
          console.error(error);
        } finally {
          if (state.controller === controller) state.controller = null;
        }
      }, 250);
    });

    input.addEventListener('keydown', (event) => {
      if (state.results.hidden || !state.options.length) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActiveOption(state, state.activeIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActiveOption(state, state.activeIndex <= 0 ? state.options.length - 1 : state.activeIndex - 1);
      } else if (event.key === 'Home') {
        event.preventDefault();
        setActiveOption(state, 0);
      } else if (event.key === 'End') {
        event.preventDefault();
        setActiveOption(state, state.options.length - 1);
      } else if (event.key === 'Enter' && state.activeIndex >= 0) {
        event.preventDefault();
        state.options[state.activeIndex]?.click();
      }
    });

    results.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-md-search-close]');
      if (!closeButton) return;
      closeSearch(state, { focus: true });
    });
  });

  document.addEventListener('click', (event) => {
    searches.forEach((state) => {
      if (!state.search.contains(event.target)) closeSearch(state);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    searches.forEach((state) => {
      if (!state.results.hidden) closeSearch(state, { focus: true });
    });
  });
});
